var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tttCarouselEnclosure"},[_c('ssr-carousel',{key:_vm.carouselContents.length,staticClass:"tttCarousel",attrs:{"slides-per-page":3,"gutter":40,"paginate-by-slide":true,"peek-left":24,"peek-right":24,"no-drag":false,"responsive":[
      {
        maxWidth: 1350,
        slidesPerPage: 1,
        paginateBySlide: true,
        gutter: 40,
        peekLeft: 24,
        peekRight: 24,
        noDrag: false
      },
      {
        maxWidth: 1024,
        slidesPerPage: 1,
        paginateBySlide: true,
        gutter: 24,
        peekLeft: 24,
        peekRight: 24,
        noDrag: false
      },
      {
        maxWidth: 800,
        slidesPerPage: 1,
        paginateBySlide: true,
        gutter: 8,
        peekLeft: 24,
        peekRight: 24,
        noDrag: true
      }
    ]}},_vm._l((_vm.carouselContents),function(item,index){return _c('div',{key:("items" + index),ref:("divitem" + index),refInFor:true,staticClass:"slide link-unstyle",attrs:{"tabindex":"0"}},[_c(_vm.dynamicComponent,{key:("carousel-item" + index),tag:"component",attrs:{"img-u-r-l":item.imgURL,"link-i-d":item.link,"link-type":item.linkType,"title":item.title,"description":item.description,"responsive":false,"item":item}})],1)}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }